/**
 * @generated SignedSource<<935d08eb611d4c587edd8176184dfc59>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SplitDetailsContent_paymentAddresses$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useSplit_paymentAddresses">;
  readonly " $fragmentType": "SplitDetailsContent_paymentAddresses";
};
export type SplitDetailsContent_paymentAddresses$key = {
  readonly " $data"?: SplitDetailsContent_paymentAddresses$data;
  readonly " $fragmentSpreads": FragmentRefs<"SplitDetailsContent_paymentAddresses">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SplitDetailsContent_paymentAddresses",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSplit_paymentAddresses"
    }
  ],
  "type": "PaymentAddresses",
  "abstractKey": null
};

(node as any).hash = "d499565d2a73e8197e4f5974ad8242e5";

export default node;
